import { Utils } from "./Utils";

interface IEventHandler {
  Id: string;
  Event: string;
  Hander: (data: any) => void;
}

class Eventable {
  private Handlers: IEventHandler[] = [];

  On(event: string, handler: (data: any) => void): string {
    const id = Utils.GetGuid();

    this.Handlers.push({
      Id: id,
      Event: event,
      Hander: handler
    });

    return id;
  }

  Trigger(event: string, data?: any) {
    this.Handlers.filter((h) => h.Event === event).forEach((handler) => {
      handler.Hander(data);
    });
  }

  Off(id: string) {
    const idx = this.Handlers.findIndex((h) => h.Id === id);

    if(idx !== -1) this.Handlers.splice(idx, 1);
  }
}

export { Eventable }
